const TEMPLATE_URL = process.env.API_URL + '/nutritional-plan-custom/template';

const getTemplates = (context) => {
  return new Promise((resolve, reject) => {
    context.$http.get(TEMPLATE_URL)
      .then((response) => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const createTemplate = (context, payload) => {
  return new Promise((resolve, reject) => {
    context.$http.post(TEMPLATE_URL, payload)
      .then((response) => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const updateTemplate = (context, templateId, payload) => {
  return new Promise((resolve, reject) => {
    context.$http.put(TEMPLATE_URL+'/'+templateId, payload)
      .then((response) => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};
 const deleteTemplate = (context, templateId) => {
  return new Promise((resolve, reject) => {
    context.$http.delete(TEMPLATE_URL+'/'+templateId)
      .then((response) => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const getTemplateRecipes = (context, templateId, lang ) => {
  return new Promise((resolve, reject) => {
    context.$http.get(TEMPLATE_URL+'/'+templateId+'/recipes', {params: { lang }})
      .then((response) => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const getRandomRecipe = (context, mealType, currentRecipeId, lang) =>{
  return new Promise((resolve, reject) => {
    context.$http.get(TEMPLATE_URL+'/random-recipe'+ '/'+ mealType, {params: { currentRecipeId, lang }})
      .then((response) => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
}


export default {
  getTemplates,
  createTemplate,
  updateTemplate,
  deleteTemplate,
  getTemplateRecipes,
  getRandomRecipe

}



// WEBPACK FOOTER //
// ./src/brand/health/api/template/index.js